import api from './api';

export function registerApiFactory(app) {
  app.factory('ApiFactory', [
    '$q',
    function ($q) {
      return {
        get(url, config) {
          return $q.when(api.get(url, config));
        },
        post(url, data, config) {
          return $q.when(api.post(url, data, config));
        },
        put(url, data, config) {
          return $q.when(api.put(url, data, config));
        },
        patch(url, data, config) {
          return $q.when(api.patch(url, data, config));
        },
        delete(url, config) {
          return $q.when(api.delete(url, config));
        },
      };
    },
  ]);
}
